import SectionTitle from "../../dashboard/SectionTitle";
import { colors } from "../../../styles/colors";
import { StyledJoinLinkItem } from "./index.styled";
import CopyButton from "../CopyButton";
import NoJoinLinks from "./NoJoinLinks";

interface JoinLinksProps {
  joinLinks: {
    id: number;
    text: string;
    shortLink?: string;
    longLink: string;
    name: string;
    short_link_id?: string;
    triggerId: number;
  }[];
}

const JoinLinks = ({ joinLinks }: JoinLinksProps) => {
  return (
    <>
      <SectionTitle
        title="קישורים להצטרפות"
        titleStyle={{ fontSize: "14px", color: colors.blueGray }}
      />
      {joinLinks.length === 0 ? (
        <NoJoinLinks />
      ) : (
        joinLinks.map((link) => (
          <StyledJoinLinkItem key={link.id}>
            <div className="join-link-item-name">{link.name}</div>
            <div className="join-link-item-text-container">
              <div className="join-link-item-text">{link.text}</div>
              <CopyButton
                shortLink={link.shortLink}
                longLink={link.longLink}
                triggerId={link.triggerId}
              />
            </div>
          </StyledJoinLinkItem>
        ))
      )}
    </>
  );
};

export default JoinLinks;
